import React, { FunctionComponent } from "react"
import { connect } from "react-redux";
import { AppState } from "src/store";
import TaskManager from "src/utilities/TaskManager/TaskManager";
import "./MyTasks.css"
interface Props {
    UserId: string | number
}

const MyTasks: FunctionComponent<Props> = (props) => {
    return (<div className="MyTasks main-content col-sm">
        <TaskManager
            targetedUserId={props.UserId}
        />
    </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    UserId: state.user.userId
})

export default connect(mapStateToProps)(MyTasks)